export const gpsColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'Latitude',
    dataIndex: 'gps_latitude',
    align: 'center',
    key: 'gps_latitude',
  },
  {
    title: 'Longitude',
    dataIndex: 'gps_longitude',
    align: 'center',
    key: 'gps_longitude',
  },
  {
    title: 'Altitude',
    dataIndex: 'gps_altitude',
    align: 'center',
    key: 'gps_altitude',
  },
  {
    title: 'Heading',
    dataIndex: 'gps_heading',
    align: 'center',
    key: 'gps_heading',
  },
  {
    title: 'Speed',
    dataIndex: 'gps_speed',
    align: 'center',
    key: 'gps_speed',
  },
  {
    title: 'Distance',
    dataIndex: 'gps_distance',
    align: 'center',
    key: 'gps_distance',
  },
];

export const rpmColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'PORT RPM',
    dataIndex: 'port_rpm',
    align: 'center',
    key: 'port_rpm',
  },
  {
    title: 'STARBOARD RPM',
    dataIndex: 'starboard_rpm',
    align: 'center',
    key: 'starboard_rpm',
  },
];

export const rpmPortColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'PORT RPM',
    dataIndex: 'port_rpm',
    align: 'center',
    key: 'port_rpm',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'port_running_time',
    align: 'center',
    key: 'port_running_time',
  },
];

export const rpmStarboardColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'STARBOARD RPM',
    dataIndex: 'starboard_rpm',
    align: 'center',
    key: 'starboard_rpm',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'starboard_running_time',
    align: 'center',
    key: 'starboard_running_time',
  },
];

export const clutchPortColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'PORT CLUTCH',
    dataIndex: 'port_clutch',
    align: 'center',
    key: 'port_clutch',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'port_running_time',
    align: 'center',
    key: 'port_running_time',
  },
];

export const clutchStarboardColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'STARBOARD CLUTCH',
    dataIndex: 'starboard_clutch',
    align: 'center',
    key: 'starboard_clutch',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'starboard_running_time',
    align: 'center',
    key: 'starboard_running_time',
  },
];

export const clutchCenterColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'CENTER CLUTCH',
    dataIndex: 'center_clutch',
    align: 'center',
    key: 'center_clutch',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'center_running_time',
    align: 'center',
    key: 'center_running_time',
  },
];

export const fmColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'VOLUME FLOWRATE',
    dataIndex: 'volume_flowrate',
    align: 'center',
    key: 'volume_flowrate',
  },
  {
    title: 'VOLUME INVENTORY',
    dataIndex: 'volume_inventory',
    align: 'center',
    key: 'volume_inventory',
  },
  {
    title: 'VOLUME TOTAL',
    dataIndex: 'volume_total',
    align: 'center',
    key: 'volume_total',
  },
  {
    title: 'DENSITY',
    dataIndex: 'density',
    align: 'center',
    key: 'density',
  },
  {
    title: 'MASS FLOW RATE',
    dataIndex: 'mass_flow_rate',
    align: 'center',
    key: 'mass_flow_rate',
  },
  {
    title: 'MASS INVENTORY',
    dataIndex: 'mass_inventory',
    align: 'center',
    key: 'mass_inventory',
  },
  {
    title: 'MASS TOTAL',
    dataIndex: 'mass_total',
    align: 'center',
    key: 'mass_total',
  },
  {
    title: 'TEMPERATURE',
    dataIndex: 'temperature',
    align: 'center',
    key: 'temperature',
  },
];

export const aeColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'FUEL CONSUMPTION',
    dataIndex: 'fuel_cons',
    align: 'center',
    key: 'fuel_cons',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'running_time',
    align: 'center',
    key: 'running_time',
  },
  {
    title: 'VOLTAGE',
    dataIndex: 'voltage',
    align: 'center',
    key: 'voltage',
  },
  {
    title: 'AMPERE',
    dataIndex: 'ampere',
    align: 'center',
    key: 'ampere',
  },
];

export const aeColumnsCustom: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'VOLUME FLOWRATE',
    dataIndex: 'volume_flowrate',
    align: 'center',
    key: 'volume_flowrate',
  },
  {
    title: 'VOLUME INVENTORY',
    dataIndex: 'volume_inventory',
    align: 'center',
    key: 'volume_inventory',
  },
  {
    title: 'VOLUME TOTAL',
    dataIndex: 'volume_total',
    align: 'center',
    key: 'volume_total',
  },
  {
    title: 'DENSITY',
    dataIndex: 'density',
    align: 'center',
    key: 'density',
  },
  {
    title: 'MASS FLOW RATE',
    dataIndex: 'mass_flowrate',
    align: 'center',
    key: 'mass_flowrate',
  },
  {
    title: 'MASS INVENTORY',
    dataIndex: 'mass_inventory',
    align: 'center',
    key: 'mass_inventory',
  },
  {
    title: 'MASS TOTAL',
    dataIndex: 'mass_total',
    align: 'center',
    key: 'mass_total',
  },
  {
    title: 'TEMPERATURE',
    dataIndex: 'temperature',
    align: 'center',
    key: 'temperature',
  },
  {
    title: 'FUEL CONSUMPTION',
    dataIndex: 'fuel_cons',
    align: 'center',
    key: 'fuel_cons',
  },
  {
    title: 'RUNNING TIME',
    dataIndex: 'running_time',
    align: 'center',
    key: 'running_time',
  },
  {
    title: 'VOLTAGE',
    dataIndex: 'voltage',
    align: 'center',
    key: 'voltage',
  },
  {
    title: 'AMPERE',
    dataIndex: 'ampere',
    align: 'center',
    key: 'ampere',
  },
];

export const gatewayColumns: any = [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    align: 'center',
    key: 'timestamp',
  },
  {
    title: 'Date & Time',
    dataIndex: 'dateTime',
    align: 'center',
    key: 'dateTime',
    width: 150,
  },
  {
    title: 'CPU USAGE',
    dataIndex: 'cpu_usage',
    align: 'center',
    key: 'cpu_usage',
  },
  {
    title: 'MEMORY FREE',
    dataIndex: 'memory_free',
    align: 'center',
    key: 'memory_free',
  },
  {
    title: 'SPACE FREE',
    dataIndex: 'space_free',
    align: 'center',
    key: 'space_free',
  },
  {
    title: 'SIGNAL STRENGTH',
    dataIndex: 'signal_strength',
    align: 'center',
    key: 'signal_strength',
  },
];
